import { AuthenticatedIdentityApiClient } from '../apiClients/authenticatedIdentityClient/AuthenticatedIdentityApiClient';
import { BentleyEntitlementsApiClient } from '../apiClients/entitlementsClient/BentleyEntitlementsApiClient';
import { EntitlementsApiClient } from '../apiClients/entitlementsClient/EntitlementsApiClient';
import { BentleyIdentityApiClient } from '../apiClients/identityClient/BentleyIdentityApiClient';
import { IdentityApiClient } from '../apiClients/identityClient/IdentityApiClient';
import { UserApiClient } from '../apiClients/userClient/UserApiClient';
import { resetStoreSlice } from './resetStore';
export const reducers = {
    [AuthenticatedIdentityApiClient.reducerPath]: AuthenticatedIdentityApiClient.reducer,
    [EntitlementsApiClient.reducerPath]: EntitlementsApiClient.reducer,
    [BentleyEntitlementsApiClient.reducerPath]: BentleyEntitlementsApiClient.reducer,
    [IdentityApiClient.reducerPath]: IdentityApiClient.reducer,
    [BentleyIdentityApiClient.reducerPath]: BentleyIdentityApiClient.reducer,
    [UserApiClient.reducerPath]: UserApiClient.reducer,
    [resetStoreSlice.name]: resetStoreSlice.reducer,
};
export const middleware = [
    AuthenticatedIdentityApiClient.middleware,
    EntitlementsApiClient.middleware,
    BentleyEntitlementsApiClient.middleware,
    IdentityApiClient.middleware,
    BentleyIdentityApiClient.middleware,
    UserApiClient.middleware,
];
//# sourceMappingURL=store.js.map